<template>
  <div>
    <UploadVideo v-show="data.length > 0 && matchInfo.mode === 'ONLINE'" ref="uploadVideo" @changeDataUrl="changeDataUrl"/>
    <div class="row" v-for="(item, index) in data" :key="index">
      <div class="or-title">
        <span
          class="border-left"
          :style="{ 'border-left': '3px solid #b80000' }"
          >{{ item.combatName || "" }}</span
        >
      </div>
      <div class="content clearFloat">
        <div
          class="col-check"
          v-for="(cItem, cIndex) in item.details"
          :key="cIndex + '_co'"
        >
          <a-checkbox
            :value="cItem.combatDetailId"
            :disabled="
              cItem.checkSelect != cItem.combatDetailId && getItemDisable(item)
            "
            @change="ListChange(index, cIndex, $event)"
            :checked="cItem.checkSelect == cItem.combatDetailId"
          >
            {{ cItem.detailName || "" }} {{ cItem.weight || "" }}
          </a-checkbox>
          <a-button @click="$refs.uploadVideo.changeVideo(agencyId,teamId,itemData.cardId, item.combatId, cItem.combatDetailId, cItem.curTeamNumber, index)" icon="cloud-upload" size="small" type="primary" v-if="matchInfo.mode === 'ONLINE' && cItem.checkSelect === cItem.combatDetailId && getItemDisable(item)">
            上传比赛视频
          </a-button>
          <a-tag style="margin-left:10px;" v-if="videoMap[cItem.combatDetailId]" color="#87d068">
            上传成功<a-icon type="check" />
          </a-tag>
          <template v-if="cItem.checkSelect == cItem.combatDetailId && JSON.parse(item.rule).isFillWeight">
            <a-input-number placeholder="真实体重" @change="updateWeight($event, cItem.combatDetailId)" v-model="detailWeight[cItem.combatDetailId]" :min="10" />
            &ensp;KG
          </template>
          <a-select
            v-if="cItem.teams.length > 0"
            :disabled="
              cItem.checkSelect != cItem.combatDetailId && getItemDisable(item)
            "
            class="input-width"
            :key="cItem.curTeamNumber"
            :defaultValue="cItem.curTeamNumber"
            placeholder="请选择队伍编号"
            @change="combatChange(cItem, item, index, $event)"
          >
            <a-select-option
              :value="team.value"
              v-for="team in cItem.teams"
              :key="team.label"
              >{{ team.label }}</a-select-option
            >
          </a-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import UploadVideo from './UploadVideo'
export default {
  name: 'SelectProject',
  components: {
    UploadVideo
  },
  props: {
    dataList: {
      type: Array
    },
    combatTerm: {
      type: Array
    },
    detailWeight: {
      type: Object
    },
    itemData: {
      type: Object
    },
    agencyId: {
      type: Number
    },
    teamId: {
      type: Number
    }
  },
  data () {
    return {
      data: this.dataList,
      matchInfo: store.getters['match/matchInfo'],
      videoMap: {}
    }
  },
  created () {
    this.data = this.dataList
  },
  watch: {
    'dataList': function (val) { // 监听props中的属性
      this.data = val
      this.videoMap = {}
      // if (this.itemData) {
      //     if (this.itemData.combatList && this.itemData.combatList.length > 0) {
      //       let data = []
      //       val.forEach(element => {
      //         let titleArr = []
      //         element.details.forEach(ele=> {
      //           var title = this.itemData.combatList.find(item=>item.title === ele.detailName ||  ele.detailName === '丁组')
      //           if (title) {
      //             titleArr.push(ele)
      //           }
      //         })
      //         element.details = titleArr
      //         if (titleArr.length > 0) {
      //           data.push(element)
      //         }
      //       })
      //       this.data = data
      //     }
      // }

      // if (this.itemData) {
      //   if (this.itemData.combatList.length > 0) {
      //     let data = []
      //     val.forEach(element => {
      //       let combatName = this.itemData.combatList.find(item=>item.combatName === element.combatName || item.combatName === null)
      //       console.log(element)
      //       if (combatName || element.combatName === '混合团体竞技') {
      //         let titleArr = []
      //         element.details.forEach(ele=> {
      //           var title = this.itemData.combatList.find(item=>(item.combatName === element.combatName && item.title === ele.detailName && item.weight === ele.weight) || (item.combatName === element.combatName && item.title === ele.detailName && item.weight === null) || (element.combatName === '混合团体竞技' && item.title === ele.detailName) || (element.combatName === '个人竞技' && item.title === '丁组' && ele.detailName === '丁组' && (item.combatName === '个人竞技' || item.combatName === null)))
      //           if (title) {
      //             titleArr.push(ele)
      //           }
      //         });
      //         element.details = titleArr
      //         if (titleArr.length > 0) {
      //           data.push(element)
      //         }
      //       }
      //     });
      //     this.data = data
      //   } else {
      //     this.data = val
      //   }
      // }
      
    }
  },
  methods: {
    updateWeight (e, combatDetailId) {
      this.detailWeight[combatDetailId] = e
      this.$forceUpdate()
    },
    ListChange (index, cIndex, e) { // 列表box选中
      let bool = true
      if (this.combatTerm.length > 0 && e.target.checked) {
        for (let i = 0; i < this.combatTerm.length; i++) {
          let term = this.combatTerm[i]
          let projects = JSON.parse(term.project)
          let num = term.num // 可以选择的个数
          if (projects.indexOf(this.data[index].combatId) > -1) {
            // 含有该项目的配置
            let hasChoicedNum = 0 // 当前已经选择的个数
            let hasChoicedCombatName = '' // 当前已经选择的项目名称
            this.data.forEach((item, index) => {
              item.details.forEach((cItem, cIndex) => {
                if (cItem.checkSelect && projects.indexOf(item.combatId) > -1) {
                  hasChoicedNum++
                  hasChoicedCombatName += '[' + item.combatName + ']'
                  if (hasChoicedNum >= num) {
                    this.$message.error('该队员已经选择了：' + hasChoicedCombatName + '不能继续报名该项目')
                    bool = false
                    return false
                  }
                }
              })
            })
          }
        }
      }
      if (bool) {
        this.data[index]['limit'] = this.data[index].details[cIndex].curTeamNumber
        if (e.target.checked) {
          this.data[index]['checkSelect'] = e.target.value
          this.data[index].details[cIndex]['checkSelect'] = e.target.value
        } else {
          this.data[index]['checkSelect'] = null
          this.data[index].details[cIndex]['checkSelect'] = null
        }
        this.$emit('changeData', this.data)
        this.$forceUpdate()
      }
    },
    combatChange (cItem, item, index, value) { // 列表box下拉选择
      item['limit'] = value
      if (value != 0) {
        this.data[index]['limit'] = value
        cItem.curTeamNumber = value
      } else {
        this.data[index]['limit'] = 0
        cItem.curTeamNumber = 0
      }
      this.$emit('changeData', this.data)
    },
    getItemDisable (item) {
      let bool = item.details.some(cItem => cItem.checkSelect == cItem.combatDetailId)
      return bool
    },
    changeDataUrl (data) {
      this.videoMap[data.combatDetailId] = data
      this.data[data.index]['video'] = data.data
      this.$emit('changeData', this.data)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.row{
  line-height: 40px;
}
.border-left{
  padding: 0 10px;
}
.or-title{
  color: #000;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  position: relative;
  .border-left{
    padding: 0 10px;
  }
  .add-right{
    cursor: pointer;
    position: absolute;
    right: 0;
    color: #000;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
}
.content{
  background-color: #fff;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
  .col-check{
    height: 40px;
    float: left;
    margin: 7px;
    display: flex;
    align-items: center;
    border-radius: 2px;
  }
  .input-width{
    width: 70px;
  }
}

</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/SelectProject.vue